import React from 'react';

// Chakra imports
import { Flex, useColorModeValue, Image } from '@chakra-ui/react';

// Custom components
import { HSeparator } from 'theme-components/separator/Separator';

// Import logo images
import LogoLight from 'assets/logo/logo-light.png';
import LogoDark from 'assets/logo/logo-dark.png';

export function SidebarBrand() {
  //   Chakra color mode
  const logo = useColorModeValue(LogoLight, LogoDark);

  return (
    <Flex align="start" direction="column">
      <Image
        src={logo}
        alt="Sell Net Logo"
        h="70px"
        w="auto"
        objectFit="contain"
        ml="-20px"
      />
      <HSeparator mb="20px" mt="20px" />
    </Flex>
  );
}

export default SidebarBrand;
